import React from "react";
import { StyledSupportCopy, StyledSupportCopyText } from "./StyledSupportCopy";

function SupportCopy({ displayText }) {
  return (
    <StyledSupportCopy className="mls-c-match-promo__support">
      <StyledSupportCopyText>{displayText}</StyledSupportCopyText>
    </StyledSupportCopy>
  );
}

export default SupportCopy;
